import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { App } from "./App";
import appTheme from "./theme/theme";
import '@fontsource/inter'
import './index.css'
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import DownloadClientPage from "./pages/DownloadClient";
import DownloadDriverPage from "./pages/DownloadDriver";
import DriverForm from "./pages/driverForm/DriverForm";
const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={appTheme}>
      <ColorModeScript />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/movilidad-cordoba" replace />} />
          <Route path="/movilidad-cordoba" element={<App />} />
          <Route path="/download-client" element={<DownloadClientPage />} />
          <Route path="/download-driver" element={<DownloadDriverPage />} />
          <Route path="/driver-form" element={<DriverForm />} />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
